import {restapi} from "./restapi";
import {DiscardRequest, ListPage} from "../models/types";


export function getDiscardRequests(pageNumber = 1, pageSize?: number): Promise<ListPage<DiscardRequest>> {
    return restapi.get<ListPage<DiscardRequest>>('/api/v1/smt_core/discard_request/', {
        params: {page: pageNumber, page_size: pageSize}
    }).then(res => res.data);
}

export function approveDiscardRequest(id: number, reviewNotes: string): Promise<DiscardRequest> {
    return restapi.post<DiscardRequest>(`/api/v1/smt_core/discard_request/${id}/approve/`, {
        review_notes: reviewNotes
    }).then(res => res.data);
}

export function rejectDiscardRequest(id: number, reviewNotes: string): Promise<DiscardRequest> {
    return restapi.post<DiscardRequest>(`/api/v1/smt_core/discard_request/${id}/reject/`, {
        review_notes: reviewNotes
    }).then(res => res.data);
}

export function cancelDiscardRequest(id: number): Promise<void> {
    return restapi.delete(`/api/v1/smt_core/discard_request/${id}/`).then(() => undefined);
}
